import { NodeType } from 'prosemirror-model';
import { liftListItem, wrapInList } from 'prosemirror-schema-list';
import { EditorState, Transaction } from 'prosemirror-state';

import { NodeName } from '../../schema/nodes';

export class ListService {
  constructor(private nodeType: NodeType) {}

  public isActive(state: EditorState) {
    const { $from, $to } = state.selection;

    const range = $from.blockRange($to, node => node.type.name === this.nodeType.name);
    if (!range) return false;

    return this.nodeType.name === range.parent.type.name;
  }

  public toggle(state: EditorState, dispatch?: (tr: Transaction) => void) {
    const isActive = this.isActive(state);
    return isActive
      ? liftListItem(state.schema.nodes[NodeName.ListItem])(state, dispatch)
      : wrapInList(this.nodeType)(state, dispatch);
  }
}
